import '../styles/ticket-list.scss';

const updateTicketListFade = () => {
    const sections = document.querySelectorAll('.f-ticket-list');

    if (!sections.length) {
        return;
    }

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
        const content = section.querySelector('.f-ticket-list__container');

        if (!content) {
            return;
        }

        if (prefersReduced) {
            section.style.opacity = '1';
            content.style.transform = 'translate3d(0, 0, 0)';

            return;
        }

        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const startPoint = viewportHeight * 0.99;
        const endPoint = viewportHeight * 0.6;

        let progress = 0;

        if (rect.top <= startPoint) {
            progress = Math.min(1, Math.max(0, (startPoint - rect.top) / (startPoint - endPoint)));
        }

        const opacity = Math.max(0, Math.min(1, progress));
        const offsetY = Math.round((1 - opacity) * 25);

        section.style.opacity = String(opacity);
        content.style.transform = `translate3d(0, ${offsetY}px, 0)`;
    });
};

const initTicketListFade = () => {
    const sections = document.querySelectorAll('.f-ticket-list');

    if (!sections.length) {
        return;
    }

    updateTicketListFade();

    let ticking = false;
    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateTicketListFade();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTicketListFade);
} else {
    initTicketListFade();
}
